module.exports = __webpack_public_path__ + "static/img/5.8d46001.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/zh/5.png
// module id = PIMA
// module chunks = 0